import { forwardRef, useImperativeHandle, useState, useEffect } from "react"
import { array, object, func, string } from 'prop-types'
import { Tab, Tabs } from "../TabCustom"
import InputFilter from "./InputFilter"

const TabbedFilters = forwardRef(({ tabs, filters, formValues, handleInput, onTabChange, onEnter, activeTabKey }, ref) => {
    const [activeKey, setActiveKey] = useState(() => {
        if (activeTabKey) {
            const tab = tabs.find(t => t.key === activeTabKey);
            if (tab) return tab.title;
        }
        return tabs?.[0].title ?? '';
    })

    useEffect(() => {
        if (activeTabKey) {
            const tab = tabs.find(t => t.key === activeTabKey);
            if (tab) {
                setActiveKey(tab.title);
            }
        }
    }, [activeTabKey, tabs]);

    useImperativeHandle(ref, () => ({
        activeTab: activeKey
    }))

    const onTabSelect = key => {
        setActiveKey(key)
        onTabChange(tabs.find(tab => tab.title === key))
    }

    return (
        <Tabs
            id="tabs-filters"
            activeKey={activeKey}
            onSelect={onTabSelect}
        >
            {tabs.map(tab => (
                <Tab
                    key={tab.title}
                    eventKey={tab.title}
                    title={tab.title}
                >
                    <div className="tab-panel">
                        <div className="row form-basic">
                            {tab.fields.map(field => (
                                <InputFilter key={field} {...{filter: filters[field], formValues, handleInput, onEnter }} />
                            ))}
                        </div>
                    </div>
                </Tab>
            ))}
        </Tabs>
    )
})

TabbedFilters.propTypes = {
    tabs: array.isRequired,
    filters: object.isRequired,
    formValues: object.isRequired,
    handleInput: func.isRequired,
    onTabChange: func.isRequired,
    onEnter: func.isRequired,
    activeTabKey: string
}

export default TabbedFilters
